var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    staticClass: "round-button",
    style: ({
      width: _vm.size + 'px',
      height: _vm.size + 'px'
    }),
    attrs: {
      "type": _vm.type
    }
  }, [_c('span', {
    style: ({
      fontSize: _vm.fontSize + 'px'
    })
  }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae3f04c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roundButton.vue
// module id = null
// module chunks = 